export const VERSION_NAME = 'feature/DEV-00785';
export const VERSION_HASH = 'dd16eb1a3f0d4eaf98aa758c71a9d2a9fe2d0cc8';
